import { fetcher } from '@commenda/utils';

export const syncBillingAccountUsage = (accountId: string) =>
  fetcher(`commenda-billing/mirror/accounts/${accountId}/usage-syncs`, {
    method: 'POST',
  });
